import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-audience-builder',
		path: '/dashboard/comms/send_orders/:id/audience_builder',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin_comms_orders_audience_builder" */ './index'),
			{
				exportName: 'AdminCommsOrdersAudienceBuilder',
				fallback: Loading,
			},
		),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
